export default function translate(i18n, propriete) {
  let libellePropriete = propriete;
  if (propriete === 'mouvementOd.dateMouvement') return i18n.t('addOperationDiverse.informationsMouvement.dateMouvement');
  if (propriete === 'mouvementOd.Libelle') return i18n.t('addOperationDiverse.libelle');
  if (propriete === 'mouvementOd.TiersId') return i18n.t('addOperationDiverse.informationsMouvement.tiers');
  if (propriete.indexOf('lignesOd') === 0) {
    libellePropriete = libellePropriete.slice(libellePropriete.indexOf('.') + 1);
    if (libellePropriete === 'Compte') return i18n.t('addOperationDiverse.compteComptable');
    if (libellePropriete === 'Debit') return i18n.t('addOperationDiverse.debit');
    if (libellePropriete === 'Credit') return i18n.t('addOperationDiverse.credit');
    return libellePropriete;
  }
  return propriete;
}
